import BaseResource from '@/lib/data/resource/BaseResource'

export default class AssetPriceTriggerInputResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.assetCode = payload.assetCode ?? ''
    this.threshold = payload.threshold ?? ''
    this.snapshotValue = payload.snapshotValue ?? payload.threshold
  }

  /* PROPERTIES */

  /* METHODS */
}
